import React, { FC } from 'react';

import { Hyperlink } from '../Hyperlink';

import styles from './navigation_block.module.scss';

type Props = {
  blockLeft?: { href: string; text: string; source: string };
  blockRight?: { href: string; text: string; source: string };
};

export const NavigationBlock: FC<Props> = ({ blockLeft, blockRight }) => {
  return (
    <div className={styles.container}>
      {blockLeft ? (
        <Hyperlink
          href={blockLeft.href}
          source={blockLeft.source}
          className={styles.leftBlock}
        >
          <span className={styles.text}>{blockLeft.text}</span>
        </Hyperlink>
      ) : (
        <div className={styles.leftBlock} />
      )}
      {blockRight ? (
        <Hyperlink
          href={blockRight.href}
          source={blockRight.source}
          className={styles.rightBlock}
        >
          <span className={styles.text}>{blockRight.text}</span>
        </Hyperlink>
      ) : (
        <div className={styles.rightBlock} />
      )}
    </div>
  );
};
